import { useEffect, useMemo } from 'react';

import { resize, scroll } from './actions';
import { useWindowBoundingBoxReducer } from './reducer';

export const useWindowBoundingBox = () => {
  const [state, dispatch] = useWindowBoundingBoxReducer();

  useEffect(() => {
    const onResize = () => {
      dispatch(resize());
    };
    const onScroll = () => {
      dispatch(scroll());
    };

    global.window.addEventListener('resize', onResize);
    global.window.addEventListener('scroll', onScroll, true);

    return () => {
      global.window.removeEventListener('resize', onResize);
      global.window.removeEventListener('scroll', onScroll, true);
    };
    // eslint-disable-next-line
  }, []);

  const { innerWidth, innerHeight, scrollLeft, scrollTop } = state;

  return useMemo(
    () => ({
      bottom: scrollTop + innerHeight,
      height: innerHeight,
      left: scrollLeft,
      right: scrollLeft + innerWidth,
      top: scrollTop,
      width: innerWidth,
    }),
    [innerHeight, innerWidth, scrollLeft, scrollTop],
  );
};
